/** Coerce a possibly-absent field to boolean, preserving undefined for missing (nullish) values. */
export function optBool(value: unknown): boolean | undefined {
	return value != null ? Boolean(value) : undefined;
}
